import { Component } from '@acies/core';

export default class Spacer extends Component {
	public constructor(height: 'fill' | 'hug' | number = 'fill', width: 'fill' | 'hug' | number = 'fill', minHeight = 0, minWidth = 0) {
		super();
		this.height = height;
		this.minHeight = minHeight;
		this.minWidth = minWidth;
		this.width = width;
	}
}
customElements.define('ac-spacer', Spacer);
